import { Box, Button, Chip, Grid, InputBase, Stack, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import GlassCard from "../dashboard/GlassCard";
import DataModeBadge from "./DataModeBadge";
import { useTranslation } from "react-i18next";

const examples = [
  "Mostrame personas con remera roja entre las 18 y las 20",
  "Mostrame incidentes de perfumeria de los ultimos 7 dias",
  "Encontrá eventos similares a INC-7421",
];

const ForensicSearchPanel = ({ results = [], dataMode = { mode: "mock" } }) => (
  <ForensicSearchPanelInner results={results} dataMode={dataMode} />
);

const ForensicSearchPanelInner = ({ results, dataMode }) => {
  const { t } = useTranslation();
  const translatedExamples = t("platform.forensic.examples", { returnObjects: true });
  const exampleList = Array.isArray(translatedExamples) ? translatedExamples : examples;
  return (
    <Stack spacing={2.5}>
      <GlassCard hover={false}>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between" gap={2} alignItems="center">
            <Typography variant="h4">{t("platform.forensic.title")}</Typography>
            <DataModeBadge {...dataMode} />
          </Stack>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, px: 2, py: 1.5, border: "1px solid", borderColor: "divider", borderRadius: 1, bgcolor: "background.paper" }}>
            <SearchIcon color="primary" />
            <InputBase fullWidth placeholder={t("platform.forensic.placeholder")} />
            <Button variant="contained">{t("common.search")}</Button>
          </Box>
          <Stack direction="row" gap={1} flexWrap="wrap">
            {exampleList.map((example) => <Chip key={example} label={example} variant="outlined" sx={{ height: "auto", "& .MuiChip-label": { whiteSpace: "normal", py: 0.75 } }} />)}
          </Stack>
        </Stack>
      </GlassCard>
      <Grid container spacing={2}>
        {results.map((result) => (
          <Grid item xs={12} md={4} key={result.id}>
            <GlassCard hover={false}>
              <Typography variant="h5">{result.title}</Typography>
              <Typography variant="body2" color="text.secondary">{result.camera} · {result.zone} · {result.time}</Typography>
              <Chip sx={{ mt: 2 }} label={t("platform.common.confidence", { value: Math.round(result.confidence * 100) })} size="small" variant="outlined" />
            </GlassCard>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default ForensicSearchPanel;
